export class TagsController {
  constructor(className, host, node, country, map, kpi) {
    this._host = host;
    this._node = node;
    this._country = country;
    this._map = map;
    this._kpi = kpi;
    this._wrap = document.querySelector(`.${className}`);

    this._tagsColor = [
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
      '#F9F070',
    ];
    this._tagsParentElem = swim.HtmlView.fromNode(this._wrap.querySelector('.tags'));
    this._tags = {};
    this._tagslink = null;

    this._init = false;

  }

  init() {
    this.connected();
  }

    // Tag class
  connected() {
    this._tagslink = swim.nodeRef(this._host, this._node).downlinkMap().laneUri('vehicleStatusesCount')
      .didUpdate(this.updateTagsData.bind(this)).open();
  }

  updateTagsData(k, v) {
    const id = v.get('uuid').stringValue();
    const title = k.stringValue('--');

    // vehicle on map update
    let tag = this._tags[id];
    if(!tag) {
      const colorIndex = Object.keys(this._tags).length % 10;
      const color = this._tagsColor[colorIndex];
      const view = this.createTagElem(title);
      tag = this._tags[id] = {id: id, title: title , colorIndex: colorIndex, color: color, view: view, data: {key: k, value: v}};
      view.a.on('click', this.tagClick.bind(this, tag));
    }

    tag.view.value.text(`${v.get('count').numberValue(0)}`);

    if(!this._init) {
      this.tagClick(tag);
      this._init = true;
    }
  }

  createTagElem(title) {
    const li = swim.HtmlView.create('li');

    const a = li.append('a')
      .title(title)
      .setAttribute('href', '#');

    const circle = a.append('div')
      .className('circle');

    const label = a.append('span')
      .className('label')
      .text(`${title}`);

    const value = li.append('span')
      .className('status');

    this._tagsParentElem.append(li);

    return {parent: li, a: a, label: label, value: value};
  }

  tagClick(tag, event) {
    if(event) {event.preventDefault();}
    this.tagActiveClass(tag);

    // kpi1
    const kpi1 = this._kpi[0];
    kpi1.selected = tag.id;
    kpi1.color = tag.color;

    // map
    this._map.unlinkVehicles();
    this._map.linkVehicles(swim.nodeRef(this._host, `/typeStatus/${this._country}/${tag.id}`));
    this._map.vehicleColor = tag.color;

    // kpi 3
    const kpi3 = this._kpi[2];
    kpi3.unlinkVehicles();
    kpi3.linkVehicles(swim.nodeRef(this._host, `/typeStatus/${this._country}/${tag.id}`));
    kpi3.title = tag.title;
    kpi3.textColor = tag.color;
  }

  tagActiveClass(tag) {
    for(const key in this._tags) {
      const elem = this._tags[key].view.parent.removeClass('active');
    }
    tag.view.parent.addClass('active');
  }

}
